import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.css']
})
export class NewsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  news=[
    {
      title: "Wineincognito – незнакомец с силой сотни сомелье",
      img: "../../../../assets/img/newscl.png",
      subtitle: `Причиной ее посещения стало вовсе не наличие на выставке довольно весомой «винной зоны» с дегустациями вина (кстати, за это респект организаторам!) — хотя разливали всем и были очень радушны.
      И совсем не присутствие нескольких павильонов винных поставщиков (что согласитесь, тоже здорово), а небольшая, мало кому пока известная программа — WineIncognito.`,
      date:"22.03.2022"
    },
    {
      title: "Победители I дегустационного конкурса WINEINCOGNITO в Москве",
      img: "../../../../assets/img/newscl2.png",
      subtitle: `20 марта в рамках выставки Metro Expo 2019 состоялась первая масштабная экспертная дегустация вин с использованием программы WineIncognito. В числе экспертов стоит отметить Дениса Руденко, Артура Саркисяна, Александра Ставцева, Юрия Юдича, Дмитрия Мережко, Евгения Богданова, Олега Осокина ....`,
      date:"22.03.2022"
    },
    {
      title: "Wineincognito – незнакомец с силой сотни сомелье",
      img: "../../../../assets/img/newscl.png",
      subtitle: `Причиной ее посещения стало вовсе не наличие на выставке довольно весомой «винной зоны» с дегустациями вина (кстати, за это респект организаторам!) — хотя разливали всем и были очень радушны.
      И совсем не присутствие нескольких павильонов винных поставщиков (что согласитесь, тоже здорово), а небольшая, мало кому пока известная программа — WineIncognito.`,
      date:"22.03.2022"
    },
    {
      title: "Победители I дегустационного конкурса WINEINCOGNITO в Москве",
      img: "../../../../assets/img/newscl2.png",
      subtitle: `20 марта в рамках выставки Metro Expo 2019 состоялась первая масштабная экспертная дегустация вин с использованием программы WineIncognito. В числе экспертов стоит отметить Дениса Руденко, Артура Саркисяна, Александра Ставцева, Юрия Юдича, Дмитрия Мережко, Евгения Богданова, Олега Осокина ....`,
      date:"22.03.2022"
    },
  ]

}
